import Vue from 'vue'
import Vuex from 'vuex'

import apis from './modules/apis/'
import auth from './modules/auth'
import pwa from './modules/pwa'
import subscription from './modules/subscription'
import tenant from './modules/tenant'
import theme from './modules/theme'

import actions from './modules/actions'
// import connection from './modules/connection'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dev: false,
    reload: false,
  },

  getters: {
    targets: () => [
      { label: 'Fidelizzazione', value: 'visit' },
      { label: 'Rivendita', value: 'order' },
      // { label: type === 'CL' ? 'Visita' : 'Prima Visita', value: 'visit' },
      // { label: type === 'CL' ? 'Vendita' : 'Prima Vendita', value: 'order' }
    ],
    getPercent: () => (val, old) => {
      if (!old) return 100
      if (old === 0) return
      return (val - old) / old * (old > 0 ? 100 : -100)
    },
    toCamelcase: () => str => str.replace(/^([A-Z])|[\s-_](\w)/g, (_, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()),
    // .replace(/^([A-Z])|\s(\w)/g, (_, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()),
    // toCamelcase: () => str => str
    //   .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, idx) => idx === 0 ? word.toLowerCase() : word.toUpperCase())
    //   .replace(/\s+/g, ''),
    getCurrency: () => a => (a / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
    getCurrencyShort: (_, { getCurrency }) => a => {
      if (a > 10 ** 6) return (`${a / (10 ** 6)} M`).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      if (a > 10 ** 3) return (`${a / (10 ** 3)} K`).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return getCurrency(a)
    },
    groupBy: () => key => array =>
      array.reduce(
        (objectsByKeyValue, obj) => ({
          ...objectsByKeyValue,
          // eslint-disable-next-line unicorn/prefer-spread
          [obj[key]]: (objectsByKeyValue[obj[key]] || []).concat(obj),
        }),
        {},
      ),
    countValid: () => ({ filters, exclude = [], check = false }) => Object.entries(filters)
      .filter(([key, value]) => {
        // .map(([key, value]) => {
        const isArray = Array.isArray(value)
        const isObject = typeof value === 'object'
        const isString = typeof value === 'string'

        const mustExclude = !exclude.includes(key)
        let isValidArray = true
        let isValidObject = true
        let isValidString = true
        let mustCheck = true
        let notNull = true

        if (mustExclude) {
          if (isArray) isValidArray = value.length > 0
          if (!isArray && value && isObject) isValidObject = Object.values(value).some(val => !!val)
          if (isString) isValidString = value !== ''
          if (check && value) mustCheck = value[0] !== -1
          if (!isArray) notNull = value !== null
        }

        // return {
        //   key,
        //   value,
        //   result: mustExclude &&
        //     isValidArray &&
        //     isValidObject &&
        //     isValidString &&
        //     notNull &&
        //     mustCheck,
        //   types: {
        //     isArray,
        //     isObject,
        //     isString
        //   },
        //   checks: {
        //     mustExclude,
        //     isValidArray,
        //     isValidObject,
        //     isValidString,
        //     notNull,
        //     mustCheck
        //   }
        // }
        return mustExclude
          && isValidArray
          && isValidObject
          && isValidString
          && notNull
          && mustCheck
      }).length,
    // asyncForEach: () => async (arr, cb) => {
    //   for (let idx = 0; idx < arr.length; idx++) await cb(arr[idx], idx, arr)
    // },
  },

  mutations: {
    SET_DEV(state, dev) { state.dev = dev },
    SET_RELOAD(state, reload) { state.reload = reload },
  },

  modules: {
    apis,
    auth,
    tenant,
    pwa,
    subscription,
    theme,

    actions,
    // connection,
  },
})
